module.exports = __webpack_public_path__ + "static/img/background.8fc9fc6f.svg";